var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFitn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1391_48521)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1208 7.12186L20.7068 4.70686L22.7068 2.70686L21.2928 1.29286L19.2928 3.29286L16.8788 0.878859C16.6003 0.60023 16.2695 0.379206 15.9055 0.22841C15.5415 0.0776141 15.1514 0 14.7573 0C14.3633 0 13.9732 0.0776141 13.6092 0.22841C13.2452 0.379206 12.9144 0.60023 12.6358 0.878859L9.80785 3.70686L14.3428 8.24286L8.24285 14.3429L3.70685 9.80786L0.878848 12.6359C0.316434 13.1984 0.000488281 13.9614 0.000488281 14.7569C0.000488281 15.5524 0.316434 16.3153 0.878848 16.8779L3.29285 19.2929L1.29285 21.2929L2.70685 22.7069L4.70685 20.7069L7.12085 23.1209C7.39943 23.3995 7.73017 23.6205 8.09418 23.7713C8.45819 23.9221 8.84834 23.9997 9.24235 23.9997C9.63636 23.9997 10.0265 23.9221 10.3905 23.7713C10.7545 23.6205 11.0853 23.3995 11.3638 23.1209L14.1918 20.2929L9.65685 15.7569L15.7568 9.65686L20.2918 14.1919L23.1198 11.3639C23.6823 10.8013 23.9982 10.0384 23.9982 9.24286C23.9982 8.44737 23.6823 7.68444 23.1198 7.12186H23.1208Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1391_48521"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFitn);
export default __webpack_public_path__ + "static/media/FITN.3ccbaded3dd4251d32bf3fbd799e900e.svg";
export { ForwardRef as ReactComponent };